import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";
import Select from "react-select";
import {
  CheckPermission,
  LoadingSpinner,
  customOption,
  applyClassToCharacters,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiFinance } from "../../config/finance/ApiFinance";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles } from "../../helper/Method";
import { ApiFinance as ApiFinanceLocal } from "../ApiFinance";
import AddNewBankAccount from "../transfers/amanatToCashInHand/AddNewBankAccount";
import { addMember } from "../../member/ApiMember";
import { FaPlus } from "react-icons/fa";

const CustomInput = ({ autoFocus, label, name, value, onChange, error }) => (
  <FormGroup>
    <Label className="col-form-label">
      {<GetLanguageString props={label} />}
    </Label>
    <Input
      autoFocus={autoFocus}
      name={name}
      type="text"
      value={value}
      onChange={onChange}
      className="no-drag"
    />
    {error && <h4 className="text-error no-drag">{error}</h4>}
  </FormGroup>
);

// ---------------- Main Component (clone without dimensions and serial number) ----------------
const OtherIncomeLoanFromMarkaz = ({ history }) => {
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const unitTypeName = encryptStorage.getItem("unitTypeName");

  // ---------- State ----------
  const [loading, setLoading] = useState(false);

  const [unitBankAccounts, setUnitBankAccounts] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
  const [refreshBankList, setRefreshBankList] = useState(false);
  const [handleAddNew, setHandleAddNew] = useState(false);

  const [formData, setFormData] = useState({
    selectedFinanceCategory: null,
    selectedAccount: null,
    rafiqBankId: null,
    date: new Date(),
    amount: "",
    memo: "",
    receiptNumber: "",
  });

  const [errors, setErrors] = useState({});

  // ---------- Handlers ----------
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleReceiptNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFormData((prev) => ({
      ...prev,
      receiptNumber: value,
    }));
    setErrors((prev) => ({ ...prev, receiptNumber: "" }));
  };

  const handleBankAccountChange = (option) => {
    setSelectedBankAccount(option);
    setFormData((prev) => ({ ...prev, selectedBankAccount: option }));
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const isValid = validate();
    if (!isValid) {
      return;
    }
    const payload = {
      financeAccount: formData.selectedAccount ?? null,
      rafiqBankId: formData.selectedBankAccount.value ?? null,
      category: formData.selectedFinanceCategory ?? null,
      date: formData.date,
      amount: formData.amount,
      memo: formData.memo,
      unitId: loggedInUnitId,
      receiptNumber: formData.receiptNumber,
    };

    setLoading(true);
    ApiFinanceLocal()
      .AddOtherIncomeLoanFromMarkaz(payload)
      .then((res) => {
        const data = res.data;

        if (data?.statusCode === "200") {
          swal({
            title: "Success",
            text:
              t(data.message) ||
              t("finance_other_income_loan_from_markaz_requested"),
            icon: "success",
            buttons: "OK",
          }).then(() => {
            history.goBack();
          });
          return;
        }

        swal({
          title: "Error",
          text: data?.message || "Failed to add Other Income",
          icon: "error",
          buttons: "OK",
        });

        setLoading(false);
      })
      .catch(() => {
        swal({
          title: "Error",
          text: "Unable to connect to server. Please try again.",
          icon: "error",
          buttons: "OK",
        });
        setLoading(false);
      });
  };

  // ---------- Effects ----------
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetFinanceAccountCategoriesListByType("income")
      .then((res) => {
        // Prefer a category that references markaz; fallback to first
        const preferred = res.data.find(
          (c) => c.label1 && c.label1.includes("loan_markaz"),
        );
        setFormData((prev) => ({
          ...prev,
          selectedFinanceCategory: preferred || res.data[0] || null,
        }));
      })
      .catch((err) => {
        console.error(err);
        swal({
          title: err,
          text: err.response?.data,
          icon: "error",
          buttons: "OK",
        });
      })
      .finally(() => setLoading(false));
  }, [unitTypeName]);

  // Fetch unit bank accounts
  useEffect(() => {
    if (!loggedInUnitId) return;
    addMember()
      .GetUnitBankAccounts(loggedInUnitId)
      .then((res) => {
        const list = res.data || [];
        setUnitBankAccounts(list);
        if (list.length > 0 && !refreshBankList) {
          setSelectedBankAccount(list[0]);
          setFormData((prev) => ({ ...prev, selectedBankAccount: list[0] }));
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setRefreshBankList(false));
  }, [loggedInUnitId, refreshBankList]);

  console.log(formData.selectedFinanceCategory);
  

  // ---------- Validation ----------
  const validate = () => {
    const temp = {};
    temp.amount = formData.amount ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_amount_paid_error" />
    );

    temp.receiptNumber = formData.receiptNumber ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  console.log(handleAddNew);

  // ---------- Render ----------
  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      <div className="ibox">
        <div className="ibox-title d-flex justify-content-between align-items-center">
          <h5>
            {<GetLanguageString props="funds_other_income_loan_from_markaz" />}
          </h5>
          <Button
            className={GetCustomStyles().btn_style}
            color="white"
            size="xs"
            onClick={() => history.goBack()}
          >
            <IoArrowBackSharp
              color="#18A689"
              size={15}
              style={{ marginRight: 5, marginBottom: 1 }}
            />
            {<GetLanguageString props="courses_participants_back" />}
          </Button>
        </div>

        <div className="ibox-content">
          {loading ? (
            LoadingSpinner()
          ) : (
            <Form onSubmit={handleSubmit}>
              <Row>
                {handleAddNew && (
                  <AddNewBankAccount
                    setModal={setHandleAddNew}
                    getAddedBankAccount={setSelectedBankAccount}
                    setRefreshBankList={setRefreshBankList}
                  />
                )}

                <Col md="6">
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="fund_bank_account" />}
                    </Label>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <div style={{ flex: 1 }}>
                        <Select
                          components={{ Option: customOption }}
                          options={unitBankAccounts}
                          value={
                            selectedBankAccount
                              ? {
                                  value: selectedBankAccount.value,
                                  label: applyClassToCharacters(
                                    selectedBankAccount.label,
                                    "ur",
                                  ),
                                }
                              : null
                          }
                          onChange={handleBankAccountChange}
                          placeholder={t("member_select")}
                          classNamePrefix="select"
                        />
                      </div>

                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => setHandleAddNew(true)}
                        style={{
                          height: "38px", // matches Select height
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0 12px", // small compact button
                        }}
                      >
                        <FaPlus
                          color="#f7f7f7ff"
                          size={11}
                          style={{ marginRight: 5, marginBottom: 1 }}
                        />
                        {t("tutorial_add_category")}
                      </Button>
                    </div>
                  </FormGroup>
                </Col>

                {/* Income head is auto-selected from API; no select shown */}

                <Col md="3">
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="funds_date" />}
                    </Label>
                    <DatePicker
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="dd/mm/yyyy"
                      className="form-control no-drag"
                      selected={formData.date}
                      maxDate={new Date()}
                      onChange={(date) =>
                        handleChange("date", date ?? new Date())
                      }
                      dateFormat="dd/MM/yyyy"
                    />
                  </FormGroup>
                </Col>

                <Col md={"3"}>
                  <FormGroup>
                    <Label className="col-form-label">
                      {<GetLanguageString props="funds_receipt_number" />}
                    </Label>
                    <Input
                      type="text"
                      className="no-drag"
                      value={formData.receiptNumber}
                      onChange={handleReceiptNumber}
                    />
                    {errors.receiptNumber && (
                      <h4 className="text-error">{errors.receiptNumber}</h4>
                    )}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <CustomInput
                    name="memo"
                    label="transactions_memo"
                    value={formData.memo}
                    onChange={(e) => handleChange("memo", e.target.value)}
                    error={errors.memo}
                  />
                </Col>

                <Col md="3">
                  <CustomInput
                    autoFocus
                    name="amount"
                    label="funds_add_fund_amount"
                    value={formData.amount}
                    onChange={(e) => handleChange("amount", e.target.value)}
                    error={errors.amount}
                  />
                </Col>
              </Row>

              <Row>
                <Col md="9"></Col>
                <Col md="3" className="text-end">
                  {CheckPermission("CanAddFunds") ? (
                    <>
                      <Button color="white" onClick={() => history.goBack()}>
                        {<GetLanguageString props="common_cancel" />}
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        disabled={loading}
                        color="primary"
                        onClick={() => handleSubmit(false)}
                      >
                        {<GetLanguageString props="funds_add_income" />}
                      </Button>
                    </>
                  ) : null}
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(OtherIncomeLoanFromMarkaz);
